import { createTheme } from '@mui/material/styles';

// Тема Nocturne (светлая адаптация). Цвета подставляем строками var(--*) из
// src/styles/tokens.css — единая точка правки палитры остаётся там.
// Смысл этих оверрайдов: страницы не трогаем, MUI-компоненты перекрашиваются глобально.

// Всплывающие слои (меню, поповеры, дропдаун автокомплита) наследуют плоскую
// карточную тень от MuiPaper и перестают читаться как «над контентом» —
// возвращаем им нормальную тень.
const POPOVER_SHADOW = '0 6px 18px rgba(22,24,38,.12)';

const theme = createTheme({
  palette: {
    primary: {
      main: '#968ae0', // accent-500
    },
    secondary: {
      main: '#f50057',
    },
    info: {
      main: '#00bcd4',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundColor: 'var(--surface-card)',
          border: '1px solid var(--color-neutral-200)',
          borderRadius: 10,
          boxShadow: 'var(--shadow-card)',
          backgroundImage: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: { boxShadow: POPOVER_SHADOW },
      },
    },
    // Dialog — тоже всплывающий слой: без этого MuiPaper.root глушит его elevation-тень
    MuiDialog: {
      styleOverrides: {
        paper: { boxShadow: '0 12px 32px rgba(22,24,38,.2)' },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: { boxShadow: POPOVER_SHADOW },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: { boxShadow: POPOVER_SHADOW },
      },
    },
    // Плотность 0.7× — интерфейс намеренно плотный
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: 'inherit',
        },
        head: {
          fontSize: 10,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '.05em',
          color: 'var(--color-neutral-600)',
          backgroundColor: 'var(--color-neutral-100)',
          borderBottom: '1px solid var(--color-neutral-300)',
          padding: '5px 8px',
        },
        body: {
          fontSize: 12.5,
          borderBottom: '1px solid var(--color-neutral-200)',
          padding: '5px 8px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        // Скоуп на tbody — иначе подсветка липнет и к строке заголовка
        root: {
          // accent-100 (#f5f4ff) 60% — rgba вместо color-mix ради старых браузеров склада
          'tbody &:hover': {
            backgroundColor: 'rgba(245, 244, 255, 0.6)',
          },
          // у строк с пропом hover специфичность выше — дублируем, чтобы цвет был единым
          'tbody &.MuiTableRow-hover:hover': {
            backgroundColor: 'rgba(245, 244, 255, 0.6)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--color-accent-500)',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 'var(--radius-sm)' },
      },
    },
  },
});

export default theme;
